


import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
import { Link } from "react-router-dom";
import TableContainer from "Common/TableContainer";
import Select from "react-select";
import { Loader } from "../../../Common/Loader";
// Icons
import { Pencil, Search, Trash2, Plus, MoveRight } from "lucide-react";
import Modal from "Common/Components/Modal";
import DeleteModal from "Common/DeleteModal";

import { deleteRoles, getRoles } from "helpers/backend_helper";
import { ToastContainer } from "react-toastify";
import filterDataBySearch from "Common/filterDataBySearch";
import { Common } from "helpers/common";
import DualListBox from "react-dual-listbox";
import "react-dual-listbox/lib/react-dual-listbox.css";

const SalesRepBusinessMapping = () => {
    const [roles, setRoles] = useState([]);
    const [eventData, setEventData] = useState<any>();
    const [rolesData, setRolesData] = useState<any>();
    const [show, setShow] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const uiHelper = new Common();



    const options = [
        { value: "apple", label: "Apple" },
        { value: "banana", label: "Banana" },
        { value: "blueberry", label: "Blueberry" },
        { value: "cherry", label: "Cherry" },
        { value: "coconut", label: "Coconut" },
        { value: "grapefruit", label: "Grapefruit" },
        { value: "kiwi", label: "Kiwi" },
        { value: "lemon", label: "Lemon" },
        { value: "lime", label: "Lime" },
        { value: "mango", label: "Mango" },
        { value: "orange", label: "Orange" },
        { value: "papaya", label: "Papaya" },
    ];

    const Optgroup = [
        {
            label: "Cars",
            options: [
                { value: "chevrolet", label: "Chevrolet" },
                { value: "fiat", label: "Fiat" },
                { value: "ford", label: "Ford" },
                { value: "honda", label: "Honda" },
                { value: "hyundai", label: "Hyundai" },
                { value: "kia", label: "Kia" },
                { value: "mahindra", label: "Mahindra" },
                { value: "maruti", label: "Maruti" },
                { value: "mistubishi", label: "Mistubishi" },
                { value: "mg", label: "MG" },
                { value: "nissan", label: "Nissan" },
                { value: "renault", label: "Renault" },
                { value: "skoda", label: "Skoda" },
                { value: "tata", label: "Tata" },
                { value: "toyota", label: "Toyota" },
                { value: "volkswagen", label: "Volkswagen" },
            ],
        },
    ];

    const OptgroupFilter = [
        {
            label: "Skoda",
            options: [
                { value: "kushaq", label: "Kushaq" },
                { value: "superb", label: "Superb" },
                { value: "octavia", label: "Octavia" },
                { value: "rapid", label: "Rapid" },
            ],
        },
        {
            label: "Volkswagen",
            options: [
                { value: "polo", label: "Polo" },
                { value: "taigun", label: "Taigun" },
                { value: "vento", label: "Vento" },
            ],
        },
    ];

    const [selected, setSelected] = React.useState(["apple", "blueberry", "cherry"]);
    const [selectedOptGroup, setSelectedOptGroup] = React.useState(["hyundai", "skoda", "tata", "toyota",]);
    const [selectedFilter, setSelectedFilter] = React.useState(["luna"]);



    return (
        <React.Fragment>

            <ToastContainer closeButton={false} limit={1} />


            <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12" style={{ marginTop: 15 }}>
                <div className="xl:col-span-12">
                    <div className="card" id="PermissionsTable">
                        <div className="flex items-center  border-y border-dashed" style={{ padding: 10 }}>
                            <h6 className="text-15 grow">Roles</h6>
                        </div>
                        <div className="card-body  p10">
                            <DualListBox
                                canFilter
                                options={options}
                                selected={selected}
                                onChange={(e: any) => setSelected(e)}
                                icons={{
                                    moveLeft: <span className="mdi mdi-chevron-left" key="key" />,
                                    moveAllLeft: [
                                        <span className="mdi mdi-chevron-double-left" key="key" />,
                                    ],
                                    moveRight: <MoveRight />,
                                    moveAllRight: [
                                        <span className="mdi mdi-chevron-double-right" key="key" />,
                                    ],
                                    moveDown: <span className="mdi mdi-chevron-down" key="key" />,
                                    moveUp: <span className="mdi mdi-chevron-up" key="key" />,
                                    moveTop: (
                                        <span className="mdi mdi-chevron-double-up" key="key" />
                                    ),
                                    moveBottom: (
                                        <span className="mdi mdi-chevron-double-down" key="key" />
                                    ),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    );
};
export default SalesRepBusinessMapping;


